module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"buttons\">\n<% utils.forEach(formMapping.buttons, function(button){ %>\n<% var type; %>\n<% if(button.type){ %>\n<% type = button.type; %>\n<% } else { %>\n<% type = 'default'; %>\n<% } %>\n<% if(!button.privilegeCode || helpers.hasAccessTo(button.privilegeCode)){ %>\n<%- include('buttons/' + type, { formMapping: button }); %>\n<% } %>\n<% }); %>\n</div>"
  , __filename = "components/templates/core/form/elements/buttons.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"buttons\">\n")
    ; __line = 2
    ;  utils.forEach(formMapping.buttons, function(button){ 
    ; __append("\n")
    ; __line = 3
    ;  var type; 
    ; __append("\n")
    ; __line = 4
    ;  if(button.type){ 
    ; __append("\n")
    ; __line = 5
    ;  type = button.type; 
    ; __append("\n")
    ; __line = 6
    ;  } else { 
    ; __append("\n")
    ; __line = 7
    ;  type = 'default'; 
    ; __append("\n")
    ; __line = 8
    ;  } 
    ; __append("\n")
    ; __line = 9
    ;  if(!button.privilegeCode || helpers.hasAccessTo(button.privilegeCode)){ 
    ; __append("\n")
    ; __line = 10
    ; __append( include('buttons/' + type, { formMapping: button }) )
    ; __append("\n")
    ; __line = 11
    ;  } 
    ; __append("\n")
    ; __line = 12
    ;  }); 
    ; __append("\n</div>")
    ; __line = 13
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/elements/buttons.ejs

}